import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-close-button',
  standalone: true,
  imports: [],
  templateUrl: './modal-close-button.component.html',
  styleUrls: ['./modal-close-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalCloseButtonComponent {
  private _modalController = inject(ModalController);
  
  public closeModal() {
    this._modalController.dismiss().catch(e => {
      console.warn("No modal found on dismiss")
    });
}
}